import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {NatBrowseInfo, NatResidentBrowseLocationState} from './NatResidentApplicationInterface'
import {NatPutBrowseRequest, NatPutBrowseResponse} from '../repository/NatPutBrowse'
import NatResidentBrowseConfirm from './resident/NatResidentBrowseConfirm'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    location: Location<NatResidentBrowseLocationState>
}

class NatResidentBrowseConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const browseInfo: NatBrowseInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName,
            applicantFirstName,
            browseReasonDetail,
            videoRecordingPlace,
            videoRecordingDate,
            videoRecordingStartTime,
            videoRecordingEndTime,
            browsePreferredDate,
            browsePreferredStartTime,
            browsePreferredEndTime,
            accompany,
            note,
        } = browseInfo

        const request: NatPutBrowseRequest = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            browseReasonDetail: browseReasonDetail,
            videoRecordingPlace: videoRecordingPlace,
            videoRecordingDate: videoRecordingDate,
            videoRecordingStartTime: videoRecordingStartTime.time,
            videoRecordingEndTime: videoRecordingEndTime.time,
            browsePreferredDate: browsePreferredDate,
            browsePreferredStartTime: browsePreferredStartTime.time,
            browsePreferredEndTime: browsePreferredEndTime.time,
            accompany: accompany,
            note: note,
            confirmed: true,
        }

        if (!request) {
            return
        }

        try {
            const response: Nullable<NatPutBrowseResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyBrowse.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentBrowseLocationState = this.props.location.state
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/browses/input`,
            {
                replace: true,
                state: JSON.parse(JSON.stringify(locationState)),
            },
        )
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentBrowseConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>
                    修正する
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentBrowseConfirmPage)
